import HeartsWithStars from './component.jsx'
export default HeartsWithStars
